import { Component } from "@angular/core";
import { Events, IonicPage, NavController } from "ionic-angular";

import { PostsPage } from "../posts/posts";

import { AuthProvider } from "../../providers/auth/auth";
import { Brand } from "../../models/brand.model";
import { User } from "../../models/user.model";

import { BrandProvider } from "../../providers/brand/brand";

import { fadeInOutAnimation } from "../../animations/fade-in-out";

@IonicPage()
@Component({
  selector: "page-brand",
  templateUrl: "brand-selector.html",
  animations: [fadeInOutAnimation]
})
export class BrandSelectorPage {
  brands: Brand[][];
  selectedBrand: Brand;
  user: User;
  err: string;
  loading: boolean;

  constructor(
    public navCtrl: NavController,
    public events: Events,
    public brandProvider: BrandProvider,
    public authProvider: AuthProvider
  ) {}

  getBrands() {
    this.loading = true;
    this.brandProvider.getBrands().subscribe(
      brands => {
        let cpt = 1;
        let subArray: Brand[] = new Array();
        this.brands = new Array();
        for (let brand of brands) {
          if (cpt % 2 === 0) {
            subArray.push(brand);
            this.brands.push(subArray);
            subArray = new Array();
          } else {
            subArray.push(brand);
          }
          cpt++;
        }
        this.brands.push(subArray);
      },
      error => {
        this.err = <any>error;
        this.loading = false;
      },
      () => {
        this.brandProvider.getSelectedBrand().subscribe(
          brand => {
            this.selectedBrand = brand;
          },
          error => {
            this.err = <any>error;
            this.loading = false;
          },
          () => {
            this.loading = false;
          }
        );
      }
    );
  }

  reloadBrandsSelector(refresher) {
    this.getBrands();
    refresher.complete();
  }

  switchBrand(selectedBrand) {
    this.brandProvider.postSelectedBrand(selectedBrand.id).subscribe(() => {
      let brandName = selectedBrand.name
        .replace(/([a-z])([A-Z])/g, "$1-$2")
        .replace(/\s+/g, "-")
        .toLowerCase();
      this.events.publish(
        "brand:refresh",
        brandName,
        selectedBrand.brand_logo_url,
        selectedBrand.brand_white_logo_url
      );
      this.navCtrl.push(PostsPage);
    });
  }

  ionViewDidLoad() {
    this.getBrands();
  }
}



// WEBPACK FOOTER //
// ./src/pages/brand-selector/brand-selector.ts